import React from 'react'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { useTheme, makeStyles } from '@material-ui/core'

export const InfoBox = ({title, body, extra}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Container className={classes.container}>
      <Typography className={classes.title} variant="h6">
        {title}
      </Typography>
      <Typography className={classes.body} variant="body1">
        {body}
      </Typography>
      <div className={classes.extrawrapper}>
        {extra}
      </div>
    </Container>
  )
}

const useStyles = makeStyles({
  extrawrapper: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: theme => ({
    color: theme.palette.text_strong.main
  }),
  body: theme => ({
    color: theme.palette.text_weak.main
  }),
  container: theme => ({
    backgroundColor: theme.palette.infobox_bg.main,
    margin: '1rem 0'
  })
})